import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paddingTop: {
      paddingTop: theme.spacing(6),
    },
    paperContent: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    buttonWrapper: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(2),
    },
    button: {
      margin: theme.spacing(2),
    },
    buttonIcon: {
      marginRight: theme.spacing(2),
    },
    withoutBorder: {
      border: 'none',
    },
    incomeTable: {
      maxWidth: '900px',
      '& td, & th': {
        border: 'none',
        padding: '0 .5rem',
      },
    },
    fixedHeight: {
      minHeight: '70vh',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    partnerDetailForm: {
      marginTop: '34px', // form on line with partner checkbox
    },
    showLink: {
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(2),
      color: theme.palette.common.black,
      borderTop: 'solid #ccc 1px',
      cursor: 'pointer',
      display: 'block',
      width: '100%',
      '&:hover': { textDecoration: 'none' },
    },
    show: {
      float: 'right',
      display: 'inline-flex',
      alignItems: 'center',
      color: theme.palette.grey[600],
      '& svg': {
        transition: `.2s all`,
        marginLeft: theme.spacing(1)
      },
    },
    shownIcon: {
      transform: 'rotate(-180deg)',
    },
    note: {
      fontSize: '0.875rem',
      paddingTop: '10px',
    },
  }),
);
